import {Linear, Sine, TweenMax} from 'gsap';
import {composition} from './anim05';
import 'latest-createjs';
const createjs = document.createjs;
const CustomEase = require('../../../../vendors/CustomEase').default;

let _instance;

// A Singleton
export const initInstance = () => {
    if (_instance) return _instance;

    // Construct Library, Images map, Properties object
    _instance = {
        comp: composition
    };

    _instance.isCreateJS = true;

    _instance.lib = _instance.comp.getLibrary();

    _instance.getProperties = () => {
        return _instance.lib.properties;
    };

    _instance.getManifest = () => {
        // Transfer to CreateJS format: src and id props
        return [
            {src: './img/include/stories/05/ariel.png', id: 'ariel'},
            {src: './img/include/stories/05/Bitmap1.png', id: 'Bitmap1'},
            {src: './img/include/stories/05/Bitmap2.png', id: 'Bitmap2'},
            {src: './img/include/stories/05/img_05.jpg', id: 'img_05'},
            {src: './img/include/stories/05/Microphone.png', id: 'Microphone'}
        ];
    };

    _instance.getWidth = () => {
        return _instance.lib.properties.width;
    };

    _instance.getHeight = () => {
        return _instance.lib.properties.height;
    };

    _instance.getFPS = () => {
        return _instance.lib.properties.fps;
    };

    _instance.getLibrary = () => {
        return _instance.lib;
    };

    _instance.getImages = () => {
        return _instance.comp.getImages();
    };

    _instance.initiateInstances = () => {
        const ss = _instance.comp.getSpriteSheet();
        const images = _instance.getImages();
        const ssMetadata = _instance.lib.ssMetadata;
        let i;
        for (i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                images: [images[ssMetadata[i].name]],
                frames: ssMetadata[i].frames
            });
        }
        return _instance;
    };

    _instance.createMainView = () => {
        const obj = new _instance.lib.mai();
        obj.name = 'mai';
        obj.setTransform(750, 540);
        return obj;
    };

    _instance.resizeMainView = (mc, width, height, cx, cy) => {
        _instance.cx = !isNaN(cx) ? cx : 0;
        _instance.cy = !isNaN(cy) ? cy : 0;
        TweenMax.set(mc, {x: 750 - _instance.cx * 0.5, y: 620});
    };

    _instance.reset = mc => {
        const dX = _instance.cx * 1.5;
        const dY = _instance.cy;

        const xb = dX;
        const xO = 100;
        const yb = dY;
        // y stop
        const yO = 0;

        const x5 = xb;
        const x4 = (xO - xb) / 4 + xb;
        const x3 = ((xO - xb) / 4) * 2 + xb;
        const x2 = ((xO - xb) / 4) * 3 + xb;
        const x1 = ((xO - xb) / 4) * 4 + xb;

        const y5 = yb;
        const y4 = (yO - yb) / 4 + yb;
        const y3 = ((yO - yb) / 4) * 2 + yb;
        const y2 = ((yO - yb) / 4) * 3 + yb;
        const y1 = ((yO - yb) / 4) * 4 + yb;

        TweenMax.set(mc, {x: 750 - _instance.cx * 0.5, y: 620});
        // ariel
        TweenMax.set(mc.ariel, {x: -0 + dX, y: -23 + dY, scaleX: 0.5, scaleY: 0.5, alpha: 0}, 'start');

        TweenMax.set(mc.ariel.mask, {x: -336, y: -14, alpha: 1}, 'start');
        // keng
        TweenMax.set(mc.keng, {x: 224 + dX, y: 50 + dY, scaleX: 0.58, scaleY: 0.58, alpha: 1}, 'start');

        // ten

        // TweenMax.set(mc.shdw, {x: 224 + dX, y: 220 + dY, alpha: 0.1}, 'start');

        // s1
        TweenMax.set(mc.p1.mask, {x: -4 + dX, y: 0 + dY, scaleX: 0, scaleY: 0}, 'start');

        // p1
        TweenMax.set(mc.p1, {x: 4 + dX, y: 10 + dY, scaleX: 0.7, scaleY: 0.7}, 'start');

        // s2
        TweenMax.set(mc.p2.mask, {x: -50 + dX, y: -65 + dY, scaleX: 0, scaleY: 0, rotation: -84}, 'start');
        // p2
        TweenMax.set(mc.p2, {x: -100 + dX, y: 190 + dY, scaleX: 0.1, scaleY: 1}, 'start');


        // s3
        TweenMax.set(mc.p3.mask, {x: -0 + dX, y: 100 + dY, scaleX: 0, scaleY: 0}, 'start');

        // p3
        TweenMax.set(mc.p3, {x: -0 + dX, y: 100 + dY, scaleX: 0.9, scaleY: 0.9}, 'start');

        TweenMax.set(mc.p3.pt, {rotation: 0, ease: Linear.easeNone}, 'start');


        // ------------ litter---------


        TweenMax.set(mc.letter.letter1, {x: x1, y: y1, alpha: 0}, 'start');

        TweenMax.set(mc.letter.letter2, {x: x2, y: y2, alpha: 0}, 'start');

        TweenMax.set(mc.letter.letter3, {x: x3, y: y3, alpha: 0}, 'start');

        TweenMax.set(mc.letter.letter4, {x: x4, y: y4, alpha: 0}, 'start');

        TweenMax.set(mc.letter.letter5, {x: x5, y: y5, alpha: 1}, 'start');


        // ------------ litter---------
    };

    _instance.setShowAnimation = (mc, tl) => {
        _instance.reset(mc);
        return tl;
    };

    _instance.setHideAnimation = (mc, tl) => {
        _instance.reset(mc);
        return tl;
    };

    _instance.setOpenAnimation = (mc, tl, tl2) => {
        const dX = _instance.cx * 1.5;
        const dY = _instance.cy;
        if (!tl) return tl;

        const time = 0.31;
        // const ti = 0.4; // delay
        const yb = dY;
        // y stop
        const yO = 0;

        const xb = dX; // x begin
        const xO = 100; // x stop

        const x5 = xb;
        const x4 = (xO - xb) / 4 + xb;
        const x3 = ((xO - xb) / 4) * 2 + xb;
        const x2 = ((xO - xb) / 4) * 3 + xb;
        const x1 = ((xO - xb) / 4) * 4 + xb;

        const y5 = yb;
        const y4 = (yO - yb) / 4 + yb;
        const y3 = ((yO - yb) / 4) * 2 + yb;
        const y2 = ((yO - yb) / 4) * 3 + yb;
        const y1 = ((yO - yb) / 4) * 4 + yb;

        // ariel
        tl.set(mc.ariel, {x: -0 + dX, y: -23 + dY, scaleX: 0.5, scaleY: 0.5, alpha: 0}, 'start');
        tl.set(mc.ariel, {x: -0 + dX, y: -23 + dY, scaleX: 0.5, scaleY: 0.5, alpha: 1}, 'start+=0.89');
        tl.to(mc.ariel, 2, {
            x: -333,
            y: -23,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.9');

        tl.set(mc.ariel.mask, {x: -336, y: -14, alpha: 1}, 'start');
        // keng
        tl.set(mc.keng, {x: 224 + dX, y: 50 + dY, scaleX: 0.58, scaleY: 0.58, alpha: 1}, 'start');
        tl.to(mc.keng, 2, {
            x: -20,
            y: -8,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.7');

        // ten

        /*tl.set(mc.shdw, {x: 224 + dX, y: 220 + dY, alpha: 0.1}, 'start');
        tl.to(mc.shdw, 2, {
            x: -20,
            y: 260,
            alpha: 0,
            scaleX: 1.6,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.7');*/

        // s1
        tl.set(mc.p1.mask, {x: -4 + dX, y: 0 + dY, scaleX: 0, scaleY: 0}, 'start');
        tl.to(mc.p1.mask, 3.7, {
            x: -400,
            y: -90,
            scaleX: 1,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=1');

        // p1
        tl.set(mc.p1, {x: 4 + dX, y: 10 + dY, scaleX: 0.7, scaleY: 0.7}, 'start');
        tl.to(mc.p1, 3, {
            x: -437,
            y: -190,
            scaleX: 1,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=1.1');

        // s2
        tl.set(mc.p2.mask, {x: -50 + dX, y: -65 + dY, scaleX: 0, scaleY: 0, rotation: -84}, 'start');
        tl.to(mc.p2.mask, 2, {
            x: 200,
            y: -333,
            scaleX: 1,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.9');
        // p2
        tl.set(mc.p2, {x: -100 + dX, y: 190 + dY, scaleX: 0.1, scaleY: 1}, 'start');
        tl.to(mc.p2, 0.7, {
            x: 200,
            y: -520,
            scaleX: 0.1,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.9');


        // s3
        tl.set(mc.p3.mask, {x: -0 + dX, y: 100 + dY, scaleX: 0, scaleY: 0}, 'start');
        tl.to(mc.p3.mask, 3, {
            x: -250,
            y: 180,
            scaleX: 1,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.7');

        // p3
        tl.set(mc.p3, {x: -0 + dX, y: 100 + dY, scaleX: 0.9, scaleY: 0.9}, 'start');
        tl.to(mc.p3, 4, {
            x: -217,
            y: 143,
            scaleX: 1,
            scaleY: 1,
            ease: CustomEase.create('custom', 'M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1')
        }, 'start+=0.7');

        if (tl2) {
            tl2.set(mc.p3.pt, {rotation: 0, ease: Linear.easeNone}, 'start');
            tl2.to(mc.p3.pt, 160, {rotation: 360, repeat: -1, yoyo: true}, 'start');
        }

        // ------------ litter---------


        tl.set(mc.letter.letter1, {x: x1, y: y1, alpha: 0}, 'start');
        tl.fromTo(mc.letter.letter1, time + 0.4, {alpha: 0}, {
            alpha: 1,
            ease: CustomEase.create('custom', 'M0,0 C0.022,0.068 0.11,0.478 0.246,0.63 0.367,0.765 0.422,0.85 1,1')
        }, 'start+=0.9');

        tl.set(mc.letter.letter2, {x: x2, y: y2, alpha: 0}, 'start');
        tl.fromTo(
            mc.letter.letter2,
            0.18, {alpha: 0},
            {
                alpha: 1,
                ease: CustomEase.create('custom', 'M0,0 C0.026,0.136 0.064,0.548 0.2,0.7 0.321,0.835 0.406,0.902 1,1')
            },
            'start+=0.8'
        );
        tl.to(mc.letter.letter2, time + 0.3, {alpha: 0}, 'start+=0.98');

        tl.set(mc.letter.letter3, {x: x3, y: y3, alpha: 0}, 'start');
        tl.fromTo(mc.letter.letter3, 0.18, {alpha: 0}, {
            alpha: 1,
            ease: CustomEase.create('custom', 'M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1')
        }, 'start+=0.7');
        tl.to(mc.letter.letter3, time - 0.2, {alpha: 0}, 'start+=0.88');

        tl.set(mc.letter.letter4, {x: x4, y: y4, alpha: 0}, 'start');
        tl.fromTo(mc.letter.letter4, 0.18, {alpha: 0}, {
            alpha: 1,
            ease: CustomEase.create('custom', 'M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1')
        }, 'start+=0.6');
        tl.to(mc.letter.letter4, time - 0.3, {alpha: 0}, 'start+=0.78');

        tl.set(mc.letter.letter5, {x: x5, y: y5, alpha: 1}, 'start');
        tl.to(mc.letter.letter5, time, {alpha: 0}, 'start+=0.68');


        // ------------ litter---------

        return tl;
    };

    _instance.setShortOpenAnimation = (mc, tl, tl2) => {
        const dX = _instance.cx * 1.5;
        const dY = _instance.cy;
        if (!tl) return tl;

        const time = 0.31;
        // const ti = 0.4; // delay
        const yb = dY;
        // y stop
        const yO = 0;

        const xb = dX; // x begin
        const xO = 100; // x stop

        const x5 = xb;
        const x4 = (xO - xb) / 4 + xb;
        const x3 = ((xO - xb) / 4) * 2 + xb;
        const x2 = ((xO - xb) / 4) * 3 + xb;
        const x1 = ((xO - xb) / 4) * 4 + xb;

        const y5 = yb;
        const y4 = (yO - yb) / 4 + yb;
        const y3 = ((yO - yb) / 4) * 2 + yb;
        const y2 = ((yO - yb) / 4) * 3 + yb;
        const y1 = ((yO - yb) / 4) * 4 + yb;

        // ariel
        tl.set(mc.ariel, {x: -0 + dX, y: -23 + dY, scaleX: 0.5, scaleY: 0.5, alpha: 1}, 'start');
        tl.set(mc.ariel, {x: -0 + dX, y: -23 + dY, scaleX: 0.5, scaleY: 0.5, alpha: 1}, 'start+=0.89');
        tl.to(mc.ariel, 2, {
            x: -333,
            y: -23,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: Sine.easeInOut
        }, 'start+=0.9');

        tl.set(mc.ariel.mask, {x: -336, y: -14, alpha: 1}, 'start');
        // keng
        tl.set(mc.keng, {x: 224 + dX, y: 50 + dY, scaleX: 0.58, scaleY: 0.58, alpha: 1}, 'start');
        tl.to(mc.keng, 2, {
            x: -20,
            y: -8,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: Sine.easeInOut
        }, 'start+=0.7');

        // ten

        /*tl.set(mc.shdw, {x: 224 + dX, y: 220 + dY, alpha: 0.1}, 'start');
        tl.to(mc.shdw, 2, {
            x: -20,
            y: 260,
            alpha: 0,
            scaleX: 1.6,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=0.7');*/

        // s1
        tl.set(mc.p1.mask, {x: -4 + dX, y: 0 + dY, scaleX: 0, scaleY: 0}, 'start');
        tl.to(mc.p1.mask, 3.7, {
            x: -400,
            y: -90,
            scaleX: 1,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=1');

        // p1
        tl.set(mc.p1, {x: 4 + dX, y: 10 + dY, scaleX: 0.7, scaleY: 0.7}, 'start');
        tl.to(mc.p1, 3, {
            x: -437,
            y: -190,
            scaleX: 1,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=1.1');

        // s2
        tl.set(mc.p2.mask, {x: -50 + dX, y: -65 + dY, scaleX: 0, scaleY: 0, rotation: -84}, 'start');
        tl.to(mc.p2.mask, 2, {
            x: 200,
            y: -333,
            scaleX: 1,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=0.9');
        // p2
        tl.set(mc.p2, {x: -100 + dX, y: 190 + dY, scaleX: 0.1, scaleY: 1}, 'start');
        tl.to(mc.p2, 0.7, {
            x: 200,
            y: -520,
            scaleX: 0.1,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=0.9');


        // s3
        tl.set(mc.p3.mask, {x: -0 + dX, y: 100 + dY, scaleX: 0, scaleY: 0}, 'start');
        tl.to(mc.p3.mask, 3, {
            x: -250,
            y: 180,
            scaleX: 1,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=0.7');

        // p3
        tl.set(mc.p3, {x: -0 + dX, y: 100 + dY, scaleX: 0.9, scaleY: 0.9}, 'start');
        tl.to(mc.p3, 4, {
            x: -217,
            y: 143,
            scaleX: 1,
            scaleY: 1,
            ease: Sine.easeInOut
        }, 'start+=0.7');

        if (tl2) {
            tl2.set(mc.p3.pt, {rotation: 0, ease: Linear.easeNone}, 'start');
            tl2.to(mc.p3.pt, 160, {rotation: 360, repeat: -1, yoyo: true}, 'start');
        }

        // ------------ litter---------


        tl.set(mc.letter.letter1, {x: x1, y: y1, alpha: 0}, 'start');
        tl.fromTo(mc.letter.letter1, time + 0.4, {alpha: 0}, {
            alpha: 1,
            ease: Sine.easeInOut
        }, 'start+=0.9');

        tl.set(mc.letter.letter2, {x: x2, y: y2, alpha: 0}, 'start');
        tl.fromTo(
            mc.letter.letter2,
            0.18, {alpha: 0},
            {
                alpha: 1,
                ease: Sine.easeInOut
            },
            'start+=0.8'
        );
        tl.to(mc.letter.letter2, time + 0.3, {alpha: 0}, 'start+=0.98');

        tl.set(mc.letter.letter3, {x: x3, y: y3, alpha: 0}, 'start');
        tl.fromTo(mc.letter.letter3, 0.18, {alpha: 0}, {
            alpha: 1,
            ease: Sine.easeInOut
        }, 'start+=0.7');
        tl.to(mc.letter.letter3, time - 0.2, {alpha: 0}, 'start+=0.88');

        tl.set(mc.letter.letter4, {x: x4, y: y4, alpha: 0}, 'start');
        tl.fromTo(mc.letter.letter4, 0.18, {alpha: 0}, {
            alpha: 1,
            ease: Sine.easeInOut
        }, 'start+=0.6');
        tl.to(mc.letter.letter4, time - 0.3, {alpha: 0}, 'start+=0.78');

        tl.set(mc.letter.letter5, {x: x5, y: y5, alpha: 1}, 'start');
        tl.to(mc.letter.letter5, time, {alpha: 0}, 'start+=0.68');


        // ------------ litter---------

        return tl;
    };

    _instance.setCloseAnimation = (mc, tl) => {
        _instance.reset(mc);
        _instance.setShortOpenAnimation(mc, tl);
        tl.timeScale(5);
        tl.progress(1);
        tl.reverse();
        return tl;
    };

    return _instance;
};

export default initInstance;
